import { Injectable, inject } from '@angular/core';

import { FavouritesConfig } from '@frontend/sports/common/client-config-data-access';
import { LDFeatureFlags, LaunchDarklyFlagManagerService } from '@frontend/sports/launch-darkly/feature';
import { WidgetLayoutResponse, WidgetPage, WidgetType } from '@frontend/sports/types/components/widget';
import { IWidgetExperiment } from '@frontend/sports/widget/core/feature';
import { Observable, map, of } from 'rxjs';

@Injectable()
export class FavouritesGridWidgetExperimentService implements IWidgetExperiment {
    private readonly launchDarklyFlagManagerService = inject(LaunchDarklyFlagManagerService);
    private readonly favouritesConfig = inject(FavouritesConfig);
    private readonly FAVOURITES_GRID_EXPERIMENT_TiME_OUT = 2000;

    changeLayout$(widgetLayout: WidgetLayoutResponse): Observable<WidgetLayoutResponse> {
        const isFavouritesGridWidgetConfigEnabled = this.favouritesConfig.isFavouritesGridWidgetEnabled;
        const favouritesGridExperiment$ = isFavouritesGridWidgetConfigEnabled
            ? this.launchDarklyFlagManagerService.getFeatureFlagValueWithCustomConditions$(LDFeatureFlags.SportsHomeScreenYourFavouritesWidget, {
                  allowedEmissions: 1,
                  timeoutInMS: this.FAVOURITES_GRID_EXPERIMENT_TiME_OUT,
                  defaultValue: false,
              })
            : of(false);
        return favouritesGridExperiment$.pipe(
            map((isFavouritesGridExperimentEnabled) => {
                if (isFavouritesGridWidgetConfigEnabled) {
                    return this.favouritesGridExperiment(widgetLayout, isFavouritesGridExperimentEnabled);
                }
                return widgetLayout;
            }),
        );
    }

    private favouritesGridExperiment(widgetLayout: WidgetLayoutResponse, isFavouritesGridEnabled: boolean): WidgetLayoutResponse {
        if (widgetLayout.page !== WidgetPage.HomeLobby) {
            return widgetLayout;
        }

        const filteredWidgets = isFavouritesGridEnabled
            ? widgetLayout.widgets?.filter((widget) => widget.type !== WidgetType.Favourites)
            : widgetLayout.widgets?.filter((widget) => widget.type !== WidgetType.FavouritesGrid);

        return {
            ...widgetLayout,
            widgets: filteredWidgets,
        };
    }
}
